import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-5 py-10 sm:py-16 items-center justify-center" style={{
    background: 'linear-gradient(135deg, #0A0A0F 0%, #16161F 30%, #0A0A0F 60%, #0A0A0F 100%)'
  }} data-id="element-114">
      {/* Logo */}
      <span className="text-[#FF6B00] text-lg sm:text-xl font-black tracking-widest mb-3" data-id="element-115">
        🏊 EDULABS
      </span>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-4xl text-3xl sm:text-5xl md:text-7xl leading-tight mb-1" data-id="element-116">
        Todo tu año de
        <br data-id="element-117" />
        <span className="text-[#FF6B00]" data-id="element-118">Natación resuelto.</span>
      </h1>

      {/* Subheadline */}
      <p className="text-[#B0B0C0] text-sm sm:text-base max-w-md mx-auto mb-4" data-id="element-119">
        Sesiones · Técnica · Planificación · Evaluación · Gestión · Negocio
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[220px] sm:max-w-[300px] md:max-w-[360px] mx-auto mb-4" data-id="element-120">
        <img src="https://cdn.magicpatterns.com/uploads/gK1kQ8nkkenrGCujy9Kx2Z/Diseno_sin_titulo_(23).png" alt="EDULABS MegaPack Natación Listo — Combo Completo" className="w-full h-auto object-contain" width={500} height={500} fetchPriority="high" data-id="element-121" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-8 bg-[#FF6B00] opacity-15 rounded-full pointer-events-none" style={{
        filter: 'blur(30px)'
      }} data-id="element-122" />
      </div>

      {/* Pills */}
      <div className="flex flex-wrap items-center justify-center mb-5 gap-1.5" data-id="element-123">
        <span className="bg-[#FF6B0033] text-[#FF6B00] text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-124">
          📄 PDF
        </span>
        <span className="bg-[#FF6B0033] text-[#FF6B00] text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-125">
          ⚡ Acceso Inmediato
        </span>
        <span className="bg-[#FF6B0033] text-[#FF6B00] text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-126">
          🌎 Habla Hispana
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-primary-pulse bg-[#FF6B00] font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#ff8533] transition-colors inline-block mb-4 w-full sm:w-auto max-w-sm text-white" data-id="element-127">
        💪 → QUIERO MI MEGAPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-[#B0B0C0] text-[11px] sm:text-xs flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-128">
        <span data-id="element-129">🛡️ Garantía 7 días</span>
        <span data-id="element-130">🔒 Pago seguro</span>
        <span data-id="element-131">💳 Tarjetas | PayPal</span>
      </p>
    </section>;
}